import analysisTemplateActionTypes from "./AnalysisTemplateConstants.js";
function setRouteContext(routeContext) {
  return {
    type: analysisTemplateActionTypes.SET_ROUTE_CONTEXT,
    payload: routeContext
  };
}
function setPartialUserContext(userContext) {
  return {
    type: analysisTemplateActionTypes.SET_PARTIAL_USER_CONTEXT,
    payload: userContext
  };
}
function setUserContext(userContext) {
  return {
    type: analysisTemplateActionTypes.SET_USER_CONTEXT,
    payload: userContext
  };
}
function loadTemplateAbstracts() {
  return {
    type: analysisTemplateActionTypes.LOAD_TEMPLATE_ABSTRACTS,
    payload: null
  };
}
function loadingTemplateAbstracts() {
  return {
    type: analysisTemplateActionTypes.LOADING_TEMPLATE_ABSTRACTS,
    payload: null
  };
}
function loadedTemplateAbstracts(templateAbstracts) {
  return {
    type: analysisTemplateActionTypes.LOADED_TEMPLATE_ABSTRACTS,
    payload: templateAbstracts
  };
}
function loadTemplate(templateName) {
  return {
    type: analysisTemplateActionTypes.LOAD_TEMPLATE,
    payload: templateName
  };
}
function loadingTemplate() {
  return {
    type: analysisTemplateActionTypes.LOADING_TEMPLATE,
    payload: null
  };
}
function loadedTemplate(templateContent) {
  return {
    type: analysisTemplateActionTypes.LOADED_TEMPLATE,
    payload: templateContent
  };
}
function setTemplateEditContent(editContent) {
  return {
    type: analysisTemplateActionTypes.SET_TEMPLATE_EDIT_CONTENT,
    payload: editContent
  };
}
function saveTemplate(payload) {
  return {
    type: analysisTemplateActionTypes.SAVE_TEMPLATE,
    payload
  };
}
function savingTemplate() {
  return {
    type: analysisTemplateActionTypes.SAVING_TEMPLATE,
    payload: null
  };
}
function savedTemplate(error) {
  return {
    type: analysisTemplateActionTypes.SAVED_TEMPLATE,
    payload: error
  };
}
function createTemplate(payload) {
  return {
    type: analysisTemplateActionTypes.CREATE_TEMPLATE,
    payload
  };
}
function creatingTemplate() {
  return {
    type: analysisTemplateActionTypes.CREATING_TEMPLATE,
    payload: null
  };
}
function createdTemplate(error) {
  return {
    type: analysisTemplateActionTypes.CREATED_TEMPLATE,
    payload: error
  };
}
function navigateToTemplate(templateName) {
  return {
    type: analysisTemplateActionTypes.NAVIGATE_TO_TEMPLATE,
    payload: templateName
  };
}
function toggleEditorTheme() {
  return {
    type: analysisTemplateActionTypes.TOGGLE_EDITOR_THEME,
    payload: null
  };
}
const registerDataSource = (metricSetCreateOrUpdateRequestDto) => {
  return {
    type: analysisTemplateActionTypes.REGISTER_DATA_SOURCE,
    payload: metricSetCreateOrUpdateRequestDto
  };
};
const registeringDataSource = () => {
  return {
    type: analysisTemplateActionTypes.REGISTERING_DATA_SOURCE,
    payload: null
  };
};
const registeredDataSource = (registerDataSourceAsync) => {
  return {
    type: analysisTemplateActionTypes.REGISTERED_DATA_SOURCE,
    payload: registerDataSourceAsync
  };
};
export {
  createTemplate,
  createdTemplate,
  creatingTemplate,
  loadTemplate,
  loadTemplateAbstracts,
  loadedTemplate,
  loadedTemplateAbstracts,
  loadingTemplate,
  loadingTemplateAbstracts,
  navigateToTemplate,
  registerDataSource,
  registeredDataSource,
  registeringDataSource,
  saveTemplate,
  savedTemplate,
  savingTemplate,
  setPartialUserContext,
  setRouteContext,
  setTemplateEditContent,
  setUserContext,
  toggleEditorTheme
};
//# sourceMappingURL=AnalysisTemplateActions.js.map
